import {array, number, object, string} from 'yup';

import {OnboardingStatus, OnboardingType} from '../types';

export const onboardingV8nSchema = object().shape({
  type: string().oneOf(Object.values(OnboardingType)).required(),
  config: string().required(),
  geo_configs_count: number().integer().required(),
});

export const v8nSchemaOfGetOnboardingsResponse =
  array().of(onboardingV8nSchema);

export const onboardingGeoConfigV8nSchema = object().shape({
  id: string().required(),
  country_code: string().required(),
  config: string().required(),
});

export const onboardingExtDataConfigV8nSchema = object().shape({
  id: string().required(),
  ext_name: string().required(),
  ext_value: string().required(),
  config: string().required(),
  priority: number().integer().required(),
});

export const onboardingDetailsV8nSchema = object().shape({
  type: string().oneOf(Object.values(OnboardingType)).required(),
  config: string().required(),
  geo_configs: array().of(onboardingGeoConfigV8nSchema).required(),
  ext_data_configs: array().of(onboardingExtDataConfigV8nSchema).required(),
});

export const userOnboardingStatusV8nSchema = object().shape({
  type: string().oneOf(Object.values(OnboardingType)).required(),
  config: string().required(),
  status: string().oneOf(Object.values(OnboardingStatus)).required(),
});

export const v8nSchemaOfGetUserOnboardingStatusesResponse = object().shape({
  onboardings: array().of(userOnboardingStatusV8nSchema).required(),
});
